import { render, staticRenderFns } from "./assignPromoter.vue?vue&type=template&id=1fbc5cac&scoped=true"
import script from "./assignPromoter.vue?vue&type=script&lang=js"
export * from "./assignPromoter.vue?vue&type=script&lang=js"
import style0 from "./assignPromoter.vue?vue&type=style&index=0&id=1fbc5cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc5cac",
  null
  
)

export default component.exports